import { createSelector } from '@ngrx/store';
import { queueHistoryRegisterSelector } from './queue-history-register.reducer';

export const selectFilters = createSelector(queueHistoryRegisterSelector, (state) => {
   return state.filters;
});
export const selectOrderingOptions = createSelector(queueHistoryRegisterSelector, (state) => {
   return state.orderingOptions;
});
